import { call, put, all, takeEvery, take, select } from 'redux-saga/effects';
import * as UrlUtil from '../../utils/UrlUtil';
import {
    FETCH_POWER_GUIDANCE,
    FINISHED_FETCHING_POWER_GUIDANCE,
    FETCHING_POWER_GUIDANCE_ERROR,
    FETCHING_POWER_GUIDANCE_START,
    SAVE_POWER_GUIDANCE,
    SEND_POWER_GUIDANCE_TO_DEVICE,
    DUPLICATE_POWER_GUIDANCE_STRATEGY,
    SEND_POWER_GUIDANCE_TO_DEVICE_SUCCESS,
    SEND_POWER_GUIDANCE_TO_DEVICE_ERROR,
    DUPLICATE_POWER_GUIDANCE_ERROR,
    DELETE_POWER_GUIDANCE,
    DELETE_POWER_GUIDANCE_SUCCESS,
    DELETE_POWER_GUIDANCE_ERROR,
    FETCH_POWER_GUIDANCE_COURSE_DETAILS,
    FETCH_POWER_GUIDANCE_COURSE_DETAILS_SUCCESS,
    FETCH_POWER_GUIDANCE_COURSE_DETAILS_FAIL,
    FETCH_POWER_GUIDANCE_DETAILS,
    FETCH_POWER_GUIDANCE_DETAILS_SUCCESS,
    FETCH_POWER_GUIDANCE_DETAILS_FAIL,
    SAVE_POWER_GUIDANCE_SUCCESS,
    SAVE_POWER_GUIDANCE_FAIL,
    UPDATE_POWER_GUIDANCE,
    UPDATE_POWER_GUIDANCE_SUCCESS,
    UPDATE_POWER_GUIDANCE_FAIL,
    FETCH_FITNESS_STATS_START,
    FETCH_FITNESS_STATS_SUCCESS,
    FETCH_FITNESS_STATS_ERROR,
    FETCH_FITNESS_STATS,
    UPDATE_POWER_ZONES,
    UPDATE_POWER_ZONES_START,
    UPDATE_POWER_ZONES_SUCCESS,
    UPDATE_POWER_ZONES_ERROR,
    SAVE_POWER_ZONES_FROM_USER_INFO,
    SAVE_POWER_ZONES_FROM_USER_INFO_START,
    SAVE_POWER_ZONES_FROM_USER_INFO_SUCCESS,
    SAVE_POWER_ZONES_FROM_USER_INFO_ERROR,
    FETCH_LATEST_FUNCTIONAL_THRESHOLD_START,
    FETCH_LATEST_FUNCTIONAL_THRESHOLD_SUCCESS,
    FETCH_LATEST_FUNCTIONAL_THRESHOLD_ERROR,
    FETCH_LATEST_FUNCTIONAL_THRESHOLD,
    FETCHING_POWER_GUIDE_BY_COURSE_ID_START,
    FINISHED_FETCHING_POWER_GUIDE_BY_COURSE_ID,
    FETCHING_POWER_GUIDE_BY_COURSE_ID_START_ERROR,
    FETCH_POWER_GUIDE_BY_COURSE_ID
} from '../../actions/ActionTypes';
import { chinaInterpreterSetPowerGuidance } from 'actions/chinaInterpreterActions';
import { selectChinaInterpreterPowerGuidanceAlgorithmData } from 'reducers/chinaInterpreterReducer/chinaInterpreterReducer';

import { isChinaUser } from '../../utils/ChinaUtil';
import { toQueryString } from '../../utils/UrlUtil';
import { gcApi } from 'config/axios';
import NavigationUtil from 'utils/NavigationUtil';

// worker
export function* fetchPowerGuidanceList() {
    try {
        yield put({
            type: FETCHING_POWER_GUIDANCE_START
        });

        const response = yield call(gcApi.get, '/v1/powerguidances/summaries');

        yield put({
            type: FINISHED_FETCHING_POWER_GUIDANCE,
            data: response && response.data ? response.data : {}
        });
    } catch (e) {
        yield put({
            type: FETCHING_POWER_GUIDANCE_ERROR
        });
    }
}

export function* fetchPowerGuideByCourseId(action) {
    try {
        yield put({
            type: FETCHING_POWER_GUIDE_BY_COURSE_ID_START
        });

        let courseId = action.courseId;
        const response = yield call(gcApi.get, `/v1/powerguidances/summaries?courseId=${courseId}`);

        yield put({
            type: FINISHED_FETCHING_POWER_GUIDE_BY_COURSE_ID,
            data: response && response.data ? response.data : {}
        });
    } catch (e) {
        yield put({
            type: FETCHING_POWER_GUIDE_BY_COURSE_ID_START_ERROR
        });
    }
}

export function* deletePowerGuidance(action) {
    try {
        const response = yield call(gcApi.delete, `/v1/powerguidances/${action.powerGuidanceId}`);
        yield put({
            type: DELETE_POWER_GUIDANCE_SUCCESS
        });
        if (action.shouldRedirectAfterDelete) NavigationUtil.navigate('/power-guidance');
    } catch (e) {
        yield put({
            type: DELETE_POWER_GUIDANCE_ERROR
        });
    }
}
export function* fetchCourseDetailForPowerGuidance(action) {
    try {
        let queryString = '';
        let courseResponse = null;
        if (isChinaUser()) {
            queryString = toQueryString({
                targetCoordinateSystem: 'BD09'
            });
            const responses = yield all([
                call(gcApi.get, `/course-service/course/${action.courseId}${queryString}`),
                call(gcApi.get, `/course-service/course/${action.courseId}`)
            ]);

            /**
             * china mode, we use shifted response
             */
            courseResponse = responses[0];

            /**
             * we need original geoPoints for calculation
             */
            const originalCourseResponse = responses[1];
            yield put(
                chinaInterpreterSetPowerGuidance({
                    geoPoints: originalCourseResponse.data?.geoPoints
                })
            );
        } else {
            courseResponse = yield call(gcApi.get, `/course-service/course/${action.courseId}${queryString}`);
        }

        yield put({
            type: FETCH_POWER_GUIDANCE_COURSE_DETAILS_SUCCESS,
            course: courseResponse.data,
            overWritePowerGuidance: action.overWritePowerGuidance
        });
    } catch (e) {
        yield put({
            type: FETCH_POWER_GUIDANCE_COURSE_DETAILS_FAIL,
            course: {}
        });
    }
}

export function* fetchPowerGuidanceDetails(action) {
    try {
        const response = yield call(gcApi.get, `/v1/powerguidances/${action.powerGuidancePk}`);

        yield put({
            type: FETCH_POWER_GUIDANCE_DETAILS_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_POWER_GUIDANCE_DETAILS_FAIL,
            data: {}
        });
    }
}

export function* duplicatePowerGuidanceStrategy(action) {
    try {
        const response = yield call(gcApi.get, `/v1/powerguidances/${action.powerGuidanceId}`);

        const { powerGuidanceSummary, powerGuidanceSplits } = response.data;
        let payload = {
            powerGuidancePk: null
        };
        let duplicateSplits = powerGuidanceSplits.map((item) => {
            item.powerGuidancePk = null;
            return item;
        });
        payload.powerGuidanceSummary = {
            ...powerGuidanceSummary,
            powerGuidancePk: null,
            powerGuidanceName: action.powerGuidanceName
        };
        payload.powerGuidanceSplits = [...duplicateSplits];

        yield put({
            type: SAVE_POWER_GUIDANCE,
            payload: payload
        });
    } catch (e) {
        yield put({
            type: DUPLICATE_POWER_GUIDANCE_ERROR,
            data: {}
        });
    }
}

export function* savePowerGuide(action) {
    let payload = action.payload;
    try {
        // if the user does not own the course and the course does not have a shareable event on it, we must copy it and use the copy
        if (action.courseNotOwned && !action.hasShareableEvent) {
            const courseResponse = yield call(
                gcApi.get,
                `/course-service/course/copyExistingCourse/${action.payload.powerGuidanceSummary.coursePk}`
            );

            payload.powerGuidanceSummary.coursePk = courseResponse.data.courseId;
        }

        if (isChinaUser()) {
            const chinaInterpreterPowerGuidanceAlogorithmData = yield select(
                selectChinaInterpreterPowerGuidanceAlgorithmData
            );
            /** use source geo points calculated data */
            if (chinaInterpreterPowerGuidanceAlogorithmData) {
                payload.powerGuidanceSummary = {
                    ...payload.powerGuidanceSummary,
                    ...chinaInterpreterPowerGuidanceAlogorithmData.summary
                };
                payload.powerGuidanceSplits = chinaInterpreterPowerGuidanceAlogorithmData.splits;
            }
        }

        const response = yield call(gcApi.post, `/v1/powerguidances`, payload);

        yield put({
            type: SAVE_POWER_GUIDANCE_SUCCESS,
            data: response.data
        });

        const {
            powerGuidancePk,
            powerGuidanceSummary: { coursePk }
        } = response.data;

        NavigationUtil.navigate(`/power-guidance/create-strategy/${coursePk}/${powerGuidancePk}`);
    } catch (e) {
        yield put({
            type: SAVE_POWER_GUIDANCE_FAIL,
            data: {}
        });
    }
}

export function* sendPowerGuidanceToDevice(action) {
    try {
        const { powerGuidanceId, deviceId } = action.value;
        const response = yield call(gcApi.post, `/v1/powerguidances/${powerGuidanceId}/device/${deviceId}`);
        yield put({
            type: SEND_POWER_GUIDANCE_TO_DEVICE_SUCCESS
        });
    } catch (e) {
        yield put({
            type: SEND_POWER_GUIDANCE_TO_DEVICE_ERROR,
            data: {}
        });
    }
}

export function* updatePowerGuide(action) {
    let payload = action.payload;
    let powerGuideId = action.payload.powerGuidancePk;

    try {
        const response = yield call(gcApi.put, `/v1/powerguidances/${powerGuideId}`, payload);

        yield put({
            type: UPDATE_POWER_GUIDANCE_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: UPDATE_POWER_GUIDANCE_FAIL,
            data: {}
        });
    }
}

export function* fetchFitnessStats(action) {
    yield put({
        type: FETCH_FITNESS_STATS_START
    });
    try {
        const { aggregation, groupBy, startDate, endDate, metrics, activityType } = action.payload;
        const queryParams = UrlUtil.toQueryString({
            aggregation,
            groupByParentActivityType: groupBy === 'ACTIVITY',
            groupByEventType: groupBy === 'EVENT',
            activityType,
            startDate,
            endDate,
            metric: metrics
        });
        const response = yield call(gcApi.get, `/fitnessstats-service/activity${queryParams}`);
        let statsData = response.data && response.data[0] ? response.data[0].stats : {};
        yield put({
            type: FETCH_FITNESS_STATS_SUCCESS,
            data: statsData
        });
    } catch (e) {
        yield put({
            type: FETCH_FITNESS_STATS_ERROR
        });
    }
}

export function* updatePowerZones(action) {
    try {
        yield put({
            type: UPDATE_POWER_ZONES_START
        });
        const response = yield call(gcApi.put, '/biometric-service/powerZones/all', [action.payload]);

        yield put({
            type: UPDATE_POWER_ZONES_SUCCESS
        });
    } catch (e) {
        yield put({
            type: UPDATE_POWER_ZONES_ERROR
        });
    }
}

export function* savePowerZonesFromUserInfo(action) {
    try {
        yield put({
            type: SAVE_POWER_ZONES_FROM_USER_INFO_START
        });
        const response = yield call(gcApi.post, '/biometric-service/powerZones/athleteInfo', action.payload);

        yield put({
            type: SAVE_POWER_ZONES_FROM_USER_INFO_SUCCESS,
            response
        });
    } catch (e) {
        yield put({
            type: SAVE_POWER_ZONES_FROM_USER_INFO_ERROR
        });
    }
}

export function* fetchLatestFunctionalThresholdPower(action) {
    try {
        yield put({
            type: FETCH_LATEST_FUNCTIONAL_THRESHOLD_START
        });
        let specificActivity = action && action.activity ? '/' + action.activity : '';
        const response = yield call(
            gcApi.get,
            `/biometric-service/biometric/latestFunctionalThresholdPower${specificActivity}`
        );

        yield put({
            type: FETCH_LATEST_FUNCTIONAL_THRESHOLD_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_LATEST_FUNCTIONAL_THRESHOLD_ERROR
        });
    }
}

// watcher
export const powerGuidanceSagas = [
    takeEvery(FETCH_POWER_GUIDANCE, fetchPowerGuidanceList),
    takeEvery(FETCH_POWER_GUIDE_BY_COURSE_ID, fetchPowerGuideByCourseId),
    takeEvery(DELETE_POWER_GUIDANCE, deletePowerGuidance),
    takeEvery(SEND_POWER_GUIDANCE_TO_DEVICE, sendPowerGuidanceToDevice),
    takeEvery(DUPLICATE_POWER_GUIDANCE_STRATEGY, duplicatePowerGuidanceStrategy),
    takeEvery(FETCH_POWER_GUIDANCE_COURSE_DETAILS, fetchCourseDetailForPowerGuidance),
    takeEvery(SAVE_POWER_GUIDANCE, savePowerGuide),
    takeEvery(UPDATE_POWER_GUIDANCE, updatePowerGuide),
    takeEvery(FETCH_POWER_GUIDANCE_DETAILS, fetchPowerGuidanceDetails),
    takeEvery(FETCH_FITNESS_STATS, fetchFitnessStats),
    takeEvery(UPDATE_POWER_ZONES, updatePowerZones),
    takeEvery(FETCH_LATEST_FUNCTIONAL_THRESHOLD, fetchLatestFunctionalThresholdPower),
    takeEvery(SAVE_POWER_ZONES_FROM_USER_INFO, savePowerZonesFromUserInfo)
];
